import React from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

import defaultStyles from "./main.module.scss";

const PricingSection = ({ doc, sliceStyles: styles = defaultStyles }) => {
  const {
    title,
    sub_heading,
    cta_link,
    cta_text,
    button_design,
    second_cta_link,
    second_cta_text,
    second_button_design,
    lower_section_heading,
  } = doc?.primary || {};

  const getSectionItems = (sectionName) =>
    doc?.items.filter(({ section }) => section === sectionName);

  const upperSectionItems = getSectionItems("upper_section");
  const lowerSectionItems = getSectionItems("lower_section");

  const buttonStyles = {
    solid_background: styles.buttonSolidBackground,
    transparent_background: styles.buttonTransparentBackground,
    link_without_border: styles.buttonLinkWithoutBorder,
  };

  const btnClassName = `${styles.button} ${buttonStyles[button_design]}`;
  const secondBtnClassName = `${styles.button} ${buttonStyles[second_button_design]}`;

  const renderSectionBlock = ({ sectionItems, sectionClass }) =>
    sectionItems.map(({ heading, description }) => (
      <div className={sectionClass} key={heading}>
        {checkContentPresence(heading) && (
          <div className={styles.pricingSectionContentBlockHeading}>
            {textResolver(heading, { convertLabelToModular: true })}
          </div>
        )}
        {checkContentPresence(description) && (
          <div className={styles.pricingSectionContentBlockDescription}>
            {textResolver(description, { convertLabelToModular: true })}
          </div>
        )}
      </div>
    ));

  const lowerSectionLength = lowerSectionItems?.length;
  const upperSectionLength = upperSectionItems?.length;

  const customStyles = lowerSectionLength > 2;
  const customStylesUpper = upperSectionLength > 2;

  return (
    <div className={styles.pricingSectionSlice}>
      <div className={styles.pricingSectionContainer}>
        <div className={styles.pricingSectionContentContainer}>
          <div className={styles.pricingSectionHeaderBlock}>
            {checkContentPresence(title) && (
              <div className={styles.pricingSectionHeaderTitle}>
                {textResolver(title, { convertLabelToModular: true })}
              </div>
            )}
            {checkContentPresence(sub_heading) && (
              <div className={styles.pricingSectionHeaderDescription}>
                {textResolver(sub_heading, { convertLabelToModular: true })}
              </div>
            )}
          </div>

          <div
            className={`${styles.pricingSectionContentBlock} ${
              customStylesUpper ? styles.multipleUpperSectionItems : ""
            }`}
          >
            {renderSectionBlock({
              sectionItems: upperSectionItems,
              sectionClass: styles.pricingSectionContentHolder,
            })}
          </div>
          <div className={styles.pricingSectionButtonsRow}>
            <div className={styles.pricingSectionButtonsHolder}>
              {cta_link?.url && (
                <PrismicLinkTag
                  url={cta_link.url}
                  urlText={cta_text}
                  target={cta_link.target}
                  className={btnClassName}
                  convertLabelToModular
                />
              )}
            </div>
            <div className={styles.pricingSectionButtonsHolder}>
              {second_cta_link?.url && (
                <PrismicLinkTag
                  url={second_cta_link.url}
                  urlText={second_cta_text}
                  target={second_cta_link.target}
                  className={secondBtnClassName}
                  convertLabelToModular
                />
              )}
            </div>
          </div>
          {(Boolean(lowerSectionLength) || checkContentPresence(lower_section_heading)) && (
            <div className={styles.pricingSectionTimelineSection}>
              {checkContentPresence(lower_section_heading) && (
                <div className={styles.pricingSectionTimelineTitle}>
                  {textResolver(lower_section_heading, { convertLabelToModular: true })}
                </div>
              )}

              {Boolean(lowerSectionLength) && (
                <div
                  className={`${styles.pricingSectionTimelineBlocksRow} ${
                    customStyles ? styles.multipleLowerSectionItems : ""
                  }`}
                >
                  {renderSectionBlock({
                    sectionItems: lowerSectionItems,
                    sectionClass: styles.pricingSectionTimelineBlock,
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingSection;
